import { render, staticRenderFns } from "./BrDictionaryContent.vue?vue&type=template&id=f2cc8d9c&"
import script from "./BrDictionaryContent.vue?vue&type=script&lang=js&"
export * from "./BrDictionaryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports